import { React, useState, useEffect } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getCompanyDetails } from "../../Services/companyServices";
import { useNavigate, useLocation } from "react-router";

const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;
const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;
const ExportTable = styled.div`
  table {
    width: 100%;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 90px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .disabled {
    background: #f3f2f1;
  }
`;
function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}
addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const ExportCutterPdf = (props) => {
  const location = useLocation();
  const [cutterRecords, setCutterRecords] = useState(
    location?.state?.cutterRecords
  );
  const [fileNameForPDF, setFileNameForPDF] = useState(
    location?.state?.fileNameForPDF
  );
  const [company, setCompany] = useState();
  const navigate = useNavigate();
  const currentDate = new Date();
  const today =
    currentDate.getDate() +
    " " +
    currentDate.toLocaleString("default", { month: "long" }) +
    "," +
    currentDate.getFullYear();

  useEffect(() => {
    setCompanyDetails();
  }, []);

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save(fileNameForPDF + ".pdf");
      }
    );
  };

  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() =>
            navigate("../cutter-records/export-cutter", {
              state: {
                body: location?.state?.body,
                rootPage: location?.state?.rootPage,
                fileName: fileNameForPDF,
                cutterRecords: cutterRecords,
                onBack: true,
              },
            })
          }
          title="Cutter Records Preview"
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
              <Iconmoon icon="download" size={17} color="#FFFFFF" />
              Download Cutter Records
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div>
              <ExportHeader>
                <div className="file-header">
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name">
                    {company && <h4>{company.business_name} </h4>}
                    <h6>Cutter Records</h6>
                    <div className="client-data">
                      <div>
                        <label>Number of records</label>
                        <span>{cutterRecords?.length}</span>
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{today}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              <ExportTable>
              <table>
              <thead>
                    <tr>
                      <th>CUTTER CODE</th>
                      <th>CUTTER NAME</th>
                      <th>GSM RANGE</th>
                      <th>DECKLE LENGTH RANGE</th>
                      <th>DEFAULT EDGE TRIM</th>
                      <th>MAX. ALLOWED LOSS</th>
                      <th>TYPE</th>
                      <th>MAX. DIFF. IN CHOP SIZE</th>
                      <th>MIN. REEL DIA</th>
                      <th>MAX. REEL DIA</th>
                      <th>CUTTER CAPACITY</th>
                      <th>LOADING STANDS</th>
                      <th>CREATED DATE</th>
                    </tr>
                  </thead>
                  <tbody>
                  {cutterRecords?.map((cutter) => {
                      return (
                        <tr
                          className={
                            cutter.status === "Disabled" ? "disabled" : ""
                          }
                        >
                            <td>
                            <p className="p-ton f-10">{cutter.cutter_code}</p>
                            <p className="reel f-10">{cutter.status}</p>
                          </td>
                          <td>
                            <p className="p-detail f-10">{cutter.cutter_name}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.gsm_range}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.width_range}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{`Left ${cutter.left_edge_trim}`}</p>
                            <p className="p-ton f-10">{`Right ${cutter.right_edge_trim}`}</p>
                            <p className="reel f-10">{`Effective ${cutter.effective_deckle_length}`}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.maximum_loss}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.type}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.diff_chop_size}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.min_reel_dia}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.max_reel_dia}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.capacity}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.loading_stands}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{cutter.createdDate}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
              </table>
              </ExportTable>
            </div>
          </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
  );
};
export default ExportCutterPdf;
